(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('sticky_header_contents');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
         document.body.classList.add('sticky_header_contents');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
          document.body.classList.remove('sticky_header_contents');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sms-contractor-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-sms-contractor-source]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const openModal = (name) => {
      const modal = root.querySelector('[data-modal-id="' + name + '"]');
      if (!modal) return;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      const focusTarget = modal.querySelector('input, select, textarea, button');
      if (focusTarget) focusTarget.focus();
    };
    const closeModal = (modal) => {
      if (!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    };

    root.querySelectorAll('[data-modal]').forEach((trigger) => trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal(trigger.dataset.modal);
    }));
    root.querySelectorAll('[data-close]').forEach((trigger) => trigger.addEventListener('click', () => closeModal(trigger.closest('.modal'))));
    root.querySelectorAll('.modal').forEach((modal) => modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal(modal);
    }));
    root.querySelectorAll('.acc-head').forEach((head) => head.addEventListener('click', () => {
      const accordion = head.closest('.accordion');
      if (!accordion) return;
      accordion.classList.toggle('open');
      const indicator = head.querySelector('span');
      if (indicator) indicator.textContent = accordion.classList.contains('open') ? '−' : '+';
    }));

    const sticky = root.querySelector('.sticky-lead');
    const updateSticky = () => sticky?.classList.toggle('show', window.scrollY > 760);
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });

    if (root.querySelector('.sms-contractor-form-success')) openModal('contractorQuote');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-sms-contractor-source] .modal.open').forEach((modal) => {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sms-guided-builder"] && !Shopify.designMode) return;
  try {
    
const IMAGE_POOL = {
  olivia: 'https://southminisplits.com/cdn/shop/files/OliviaMainPhoto_5397d34e-b16d-4cbc-af76-9e0da7bf88d7.jpg?v=1715626682&width=900',
  indoor: 'https://southminisplits.com/cdn/shop/files/12K_BTU_OLIVIA_230V.png?v=1739375363&width=900',
  condenser: 'https://southminisplits.com/cdn/shop/files/12_000_BTU_230V_DIMS.png?v=1739375363&width=900',
  wifi: 'https://southminisplits.com/cdn/shop/files/61B267AF-32A6-44A9-A528-EE89D22FA154_600x_crop_center_6bf54c44-5117-447d-b2bc-b0d88aba6ea4.webp?v=1739375363&width=900',
  warranty: 'https://southminisplits.com/cdn/shop/files/1B1D4E48-162D-48A3-BD51-247862A30548_600x_crop_center_c42fff5d-389b-435d-95b4-a953be6fd820.webp?v=1739375363&width=900',
  energy: 'https://southminisplits.com/cdn/shop/files/BDCFFB2B-3EE1-4759-8293-403FBD1F3929_600x_crop_center_d0b6e43a-3fd7-42fb-9d3b-79b27f5317e1.webp?v=1739375363&width=900'
};

const useCaseConfig = {
  homeowner: [
    { id: 'bedroom', icon: '☾', title: 'Bedroom / office', text: 'Quiet comfort for a room that never feels right.', sqft: 350, load: 'normal' },
    { id: 'garage', icon: '▰', title: 'Garage / workshop', text: 'Higher heat gain and bigger swings.', sqft: 650, load: 'hot' },
    { id: 'sunroom', icon: '☀', title: 'Sunroom', text: 'Glass, sun, and seasonal comfort challenges.', sqft: 500, load: 'hot' },
    { id: 'adu', icon: '⌂', title: 'ADU / addition', text: 'Independent comfort without extending ducts.', sqft: 800, load: 'normal' },
    { id: 'rental', icon: '▦', title: 'Rental unit', text: 'Simple comfort for a tenant or turn.', sqft: 600, load: 'normal' },
    { id: 'large', icon: '□', title: 'Large open space', text: 'Only show larger systems when justified.', sqft: 1200, load: 'highceilings' }
  ],
  contractor: [
    { id: 'contractor', icon: '$', title: 'Price-sensitive job', text: 'Find a supported value-line alternative fast.', sqft: 750, load: 'normal' },
    { id: 'customer-supplied', icon: '!', title: 'Customer-supplied rescue', text: 'Replace risky online equipment with a sourced package.', sqft: 550, load: 'normal' },
    { id: 'garage', icon: '▰', title: 'Garage / workshop', text: 'Common budget ductless job.', sqft: 700, load: 'hot' },
    { id: 'adu', icon: '⌂', title: 'ADU / remodel', text: 'Budget-controlled ductless package.', sqft: 900, load: 'normal' },
    { id: 'rental', icon: '↻', title: 'Property turn', text: 'Repeatable packages for rental comfort.', sqft: 650, load: 'normal' },
    { id: 'large', icon: '▤', title: 'Light commercial', text: 'Bigger capacity and pro range systems.', sqft: 1300, load: 'highceilings' }
  ],
  property: [
    { id: 'rental', icon: '▦', title: 'Rental unit', text: 'Controlled cost, repeatable replacement.', sqft: 600, load: 'normal' },
    { id: 'adu', icon: '⌂', title: 'ADU / guest house', text: 'Independent comfort for separate spaces.', sqft: 800, load: 'normal' },
    { id: 'garage', icon: '⚙', title: 'Workshop / outbuilding', text: 'Comfort without adding ductwork.', sqft: 700, load: 'hot' },
    { id: 'bedroom', icon: '☾', title: 'Problem bedroom', text: 'Fix complaints without overbuilding.', sqft: 350, load: 'normal' },
    { id: 'large', icon: '▤', title: 'Small office / retail', text: 'Light commercial comfort needs.', sqft: 1100, load: 'highceilings' }
  ]
};

const state = {
  audience: 'homeowner',
  useCase: '',
  sqft: '',
  loadProfile: 'normal',
  voltage: 'any',
  priority: '',
  activeStep: 1,
  lane: 'all',
  sort: 'match',
  visibleResults: 48,
  filters: {
    btu: new Set(), brand: new Set(), voltage: new Set(), availability: new Set(), efficiency: new Set(), type: new Set()
  },
  tray: [],
  quotePlay: 'default',
  validationMessage: ''
};

const CATALOG_PAGE_NODE = document.querySelector('[data-sms-builder-catalog-page]');
const INITIAL_LIVE_PRODUCTS = parseCatalogProducts(document);
let PRODUCTS = normalizeIncomingProducts(INITIAL_LIVE_PRODUCTS);
let catalogHydrated = Number(CATALOG_PAGE_NODE?.dataset.pageCount || 1) <= 1;
let catalogHydrationPromise = null;
try {
  const savedTray = JSON.parse(window.localStorage.getItem('smsBuilderTray') || '[]');
  if (Array.isArray(savedTray)) state.tray = savedTray.filter(id => PRODUCTS.some(product => String(product.id) === String(id)));
} catch (error) {}

function parseCatalogProducts(root) {
  const node = root.querySelector('[data-sms-builder-products]');
  if (!node) return [];
  try {
    const parsed = JSON.parse(node.textContent || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function dedupeCatalogProducts(products) {
  const seen = new Set();
  return products.filter(product => {
    const key = String(product.id || product.handle || product.url || '');
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

async function loadCompleteCatalog(initialProducts) {
  const pageCount = Number(CATALOG_PAGE_NODE?.dataset.pageCount || 1);
  const currentPage = Number(CATALOG_PAGE_NODE?.dataset.currentPage || 1);
  const pageParam = CATALOG_PAGE_NODE?.dataset.pageParam || 'page';
  const catalogEndpoint = CATALOG_PAGE_NODE?.dataset.catalogEndpoint || window.location.pathname;
  if (pageCount <= 1 || !catalogEndpoint) return dedupeCatalogProducts(initialProducts);

  const pages = Array.from({ length: pageCount }, (_, index) => index + 1).filter(page => page !== currentPage);
  const collected = [...initialProducts];
  let cursor = 0;
  const workerCount = Math.min(4, pages.length);

  async function loadNextPage() {
    while (cursor < pages.length) {
      const pageNumber = pages[cursor];
      cursor += 1;
      try {
        const url = new URL(catalogEndpoint, window.location.origin);
        url.searchParams.set('view', 'sms-builder-catalog');
        url.searchParams.set(pageParam, String(pageNumber));
        const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`Catalog page ${pageNumber} returned ${response.status}`);
        const payload = await response.json();
        if (Array.isArray(payload.products)) collected.push(...payload.products);
      } catch (error) {
        console.warn('[SMS builder] Unable to load a catalog page.', error);
      }
    }
  }

  await Promise.all(Array.from({ length: workerCount }, () => loadNextPage()));
  return dedupeCatalogProducts(collected);
}

async function hydrateCompleteCatalog() {
  const completeCatalog = await loadCompleteCatalog(INITIAL_LIVE_PRODUCTS);
  PRODUCTS = normalizeIncomingProducts(completeCatalog);
  state.tray = state.tray.filter(id => PRODUCTS.some(product => String(product.id) === String(id)));
  if (CATALOG_PAGE_NODE) CATALOG_PAGE_NODE.dataset.catalogLoaded = 'true';
  renderAll();
}

function ensureCompleteCatalog() {
  if (catalogHydrated) return Promise.resolve();
  if (!catalogHydrationPromise) {
    const next = document.getElementById('nextStep');
    if (next) {
      next.disabled = true;
      next.textContent = 'Loading full catalog…';
      next.setAttribute('aria-busy', 'true');
    }
    catalogHydrationPromise = hydrateCompleteCatalog().finally(() => {
      catalogHydrated = true;
      if (next) next.removeAttribute('aria-busy');
    });
  }
  return catalogHydrationPromise;
}

function normalizeIncomingProducts(products) {
  return products.map((product, index) => {
    let indoorBtus = extractBtuValues(product.indoorUnits || product.indoorUnit || product.btu || product.capacity);
    const totalBtus = extractBtuValues(product.totalCapacity || product.totalSystemCapacity || product.outdoorUnits || product.outdoorUnit);
    if (!indoorBtus.length && totalBtus.length) indoorBtus = [...totalBtus];
    const btu = indoorBtus[0] || 0;
    if (!btu) return null;
    const totalBtu = totalBtus[0] || btu;
    const band = sqftBandForBtu(btu);
    const areaText = firstValue(product.area || product.sqftGuidance || '');
    const areaValues = String(areaText).match(/\d[\d,]*/g);
    const parsedAreas = areaValues ? areaValues.map(value => parseNumber(value)) : [];
    const price = normalizeMoney(product.price || product.price_min || 0);
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(tag => tag.trim()).filter(Boolean);
    const brand = firstValue(product.brand).trim();
    const vendor = product.vendor || brand || 'South Mini Splits';
    const voltages = normalizeVoltages(product.voltage);
    const tier = normalizeTier(product.tier || product.productTier || product.type || product.priceTier);
    return {
      id: product.id || product.variant_id || product.product_id || index + 1,
      title: product.title || `${vendor} ${btu.toLocaleString()} BTU Mini Split`,
      vendor,
      brand,
      brandKey: normalizeBrandKey(brand),
      series: firstValue(product.series || product.productFamily || '') || 'Mini Split',
      btu,
      indoorBtus,
      totalBtu,
      price,
      compareAt: normalizeMoney(product.compareAt || product.compare_at_price || product.compare_at_price_max || price * 1.12),
      voltages,
      voltage: voltages.join(' / ') || 'Voltage not populated',
      seer2: normalizeSeer2(product.seer2),
      refrigerant: firstValue(product.refrigerant) || tagValue(tags, 'refrigerant:') || 'See product details',
      minSqft: parseNumber(product.minSqft || product.min_sqft || parsedAreas[0] || band.min),
      maxSqft: /(?:and\s+up|\+|or\s+more)/i.test(areaText) ? 2500 : parseNumber(product.maxSqft || product.max_sqft || parsedAreas[parsedAreas.length - 1] || band.max),
      type: tier,
      kitStatus: firstValue(product.kitStatus || ''),
      zones: firstValue(product.zones || ''),
      available: product.available === undefined ? true : Boolean(product.available),
      productType: firstValue(product.productType || product.product_type || product.acType) || 'Mini split',
      image: product.image || product.featured_image || product.featuredImage || IMAGE_POOL.olivia,
      useCases: normalizeUseCases(product.useCases || product.use_case_fit),
      homeowner: product.homeowner === undefined ? btu <= 24000 : Boolean(product.homeowner),
      contractor: product.contractor === undefined ? true : Boolean(product.contractor),
      property: product.property === undefined ? btu <= 36000 : Boolean(product.property),
      tags,
      url: product.url || product.handle || '#',
      handle: product.handle || '',
      priceHtml: product.priceHtml || ''
    };
  }).filter(Boolean);
}

function firstValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean).join(', ');
  return value === undefined || value === null ? '' : String(value);
}
function extractBtuValues(value) {
  const items = Array.isArray(value) ? value : [value];
  const capacities = [];
  items.forEach(item => {
    if (typeof item === 'number' && Number.isFinite(item) && item > 0) {
      capacities.push(Math.round(item));
      return;
    }
    const text = String(item || '');
    const fullMatches = [...text.matchAll(/(\d{1,3}(?:,\d{3})+|\d{4,6})\s*btu\b/gi)];
    if (fullMatches.length) {
      fullMatches.forEach(match => capacities.push(parseNumber(match[1])));
      return;
    }
    const shortMatches = [...text.matchAll(/(\d{1,2}(?:\.\d+)?)\s*k(?:\s*btu)?\b/gi)];
    if (shortMatches.length) {
      shortMatches.forEach(match => capacities.push(Math.round(parseNumber(match[1]) * 1000)));
      return;
    }
    const tonMatch = text.match(/(\d+(?:\.\d+)?)\s*ton\b/i);
    if (tonMatch) capacities.push(Math.round(parseNumber(tonMatch[1]) * 12000));
  });
  return unique(capacities.filter(capacity => capacity >= 3000 && capacity <= 120000));
}
function normalizeVoltages(value) {
  const raw = firstValue(value).toUpperCase().replace(/[–—]/g, '-');
  const normalized = [];
  if (/(^|\D)(110|115|120)(\D|$)/.test(raw)) normalized.push('115V');
  if (/(^|\D)(208|220|230|240)(\D|$)/.test(raw)) normalized.push('208-230V');
  if (!normalized.length && raw.trim()) normalized.push(raw.replace(/\s+/g, ' ').trim());
  return unique(normalized);
}
function normalizeTier(value) {
  const tier = firstValue(value).trim().toLowerCase();
  if (!tier) return 'standard';
  if (tier.includes('value') || tier.includes('budget')) return 'value-line';
  if (tier.includes('contractor') || tier.includes('commercial') || tier.includes('pro')) return 'pro-range';
  if (tier.includes('premium')) return 'premium';
  return tier.replace(/\s+/g, '-');
}
function normalizeSeer2(value) {
  const rating = parseNumber(value, 0);
  return rating >= 13 && rating <= 30 ? rating : 0;
}
function normalizeUseCases(value) {
  const values = Array.isArray(value) ? value : String(value || '').split(',');
  const normalized = values.map(item => String(item).trim().toLowerCase()).filter(Boolean);
  return normalized;
}
function parseNumber(value, fallback = 0) {
  const parsed = Number(String(value ?? '').replace(/[$,]/g, ''));
  return Number.isFinite(parsed) && String(value ?? '').trim() !== '' ? parsed : fallback;
}
function normalizeMoney(value) {
  const n = parseNumber(value, 0);
  return n > 10000 ? Math.round(n / 100) : Math.round(n);
}
function tagValue(tags, prefix) {
  const match = tags.find(tag => String(tag).toLowerCase().startsWith(prefix.toLowerCase()));
  return match ? String(match).slice(prefix.length) : '';
}
function hasTag(tags, value) {
  const expected = String(value).trim().toLowerCase();
  return tags.some(tag => String(tag).trim().toLowerCase() === expected);
}
function normalizeBrandKey(value) {
  const key = firstValue(value).trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  if (key === 'cooperhunter' || key === 'cooperandhunter') return 'cooper-hunter';
  if (key === 'olmo') return 'olmo';
  if (key === 'bravo') return 'bravo';
  return key;
}
function sqftBandForBtu(btu) {
  if (btu <= 9000) return { min: 150, max: 400 };
  if (btu <= 12000) return { min: 300, max: 550 };
  if (btu <= 18000) return { min: 500, max: 850 };
  if (btu <= 24000) return { min: 750, max: 1100 };
  if (btu <= 30000) return { min: 1000, max: 1500 };
  if (btu <= 36000) return { min: 1300, max: 1800 };
  return { min: 1700, max: 2400 };
}
function money(value) { return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
function formatSeer2(value) {
  const rating = normalizeSeer2(value);
  return rating ? rating.toFixed(1) : 'Not populated';
}
function efficiencyBand(value) {
  const rating = normalizeSeer2(value);
  if (rating >= 24) return '24.0–30.0 SEER2';
  if (rating >= 20) return '20.0–23.9 SEER2';
  if (rating >= 16) return '16.0–19.9 SEER2';
  if (rating >= 13) return '13.0–15.9 SEER2';
  return '';
}
function priceBlock(product) {
  if (product.priceHtml) return product.priceHtml;
  const compare = product.compareAt > product.price ? '<span>' + money(product.compareAt) + '</span>' : '';
  return '<strong>' + money(product.price) + '</strong>' + compare;
}
function btu(value) { return Number(value).toLocaleString('en-US') + ' BTU'; }
function indoorCapacityLabel(product) {
  return (product.indoorBtus || [product.btu]).map(btu).join(' / ');
}
function capacitySummary(product) {
  const indoor = indoorCapacityLabel(product);
  return product.totalBtu && !product.indoorBtus.includes(product.totalBtu) ? `${indoor} indoor · ${btu(product.totalBtu)} total system` : indoor;
}
function escapeHTML(value) {
  return String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
}
function unique(list) { return [...new Set(list.filter(Boolean))]; }

function requiredBtu() {
  let sqft = Number(state.sqft) || 450;
  let base = sqft * 20;
  if (state.loadProfile === 'hot') base *= 1.18;
  if (state.loadProfile === 'highceilings') base *= 1.25;
  if (state.loadProfile === 'low') base *= 0.9;
  if (state.useCase === 'garage' || state.useCase === 'sunroom') base *= 1.08;
  const bands = [9000, 12000, 18000, 24000, 30000, 36000, 48000];
  return bands.reduce((best, current) => Math.abs(current - base) < Math.abs(best - base) ? current : best, bands[0]);
}

function closestIndoorCapacity(product, target) {
  const capacities = product.indoorBtus?.length ? product.indoorBtus : [product.btu];
  return capacities.reduce((best, current) => Math.abs(current - target) < Math.abs(best - target) ? current : best, capacities[0]);
}

function voltageCompatibilityGate(product) {
  return state.voltage === 'any' || product.voltages.includes(state.voltage);
}

const SHIP_FAST_BRANDS = new Set(['cooper-hunter', 'olmo', 'bravo']);

function priorityEligibilityGate(product) {
  if (state.priority === 'confidence') return hasTag(product.tags, 'DIY');
  if (state.priority === 'ship-fast') return product.available && SHIP_FAST_BRANDS.has(product.brandKey);
  if (state.priority === 'high-efficiency') return product.seer2 >= 13 && product.seer2 <= 30;
  return true;
}

function scoreProduct(product) {
  const target = requiredBtu();
  const matchedBtu = closestIndoorCapacity(product, target);
  let score = 54;
  const reasons = [];
  const cautions = [];
  const sqft = Number(state.sqft) || 0;

  const diff = Math.abs(matchedBtu - target);
  if (diff === 0) { score += 22; reasons.push(`Capacity aligns with ${btu(target)} estimate`); }
  else if (diff <= 6000) { score += 13; reasons.push(`Close capacity match for estimated load`); }
  else if (matchedBtu > target) { score -= state.audience === 'homeowner' ? 18 : 6; cautions.push('Larger than the starting estimate'); }
  else { score -= 12; cautions.push('May be undersized for the selected space'); }

  if (sqft && sqft >= product.minSqft && sqft <= product.maxSqft) { score += 14; reasons.push(`Fits ${product.minSqft}-${product.maxSqft} sq ft guidance`); }
  else if (sqft && sqft < product.minSqft) { score -= state.audience === 'homeowner' ? 12 : 5; cautions.push('Space may be smaller than this system guidance'); }
  else if (sqft && sqft > product.maxSqft) { score -= 14; cautions.push('Space may need more capacity or a closer look'); }

  if (product.useCases.includes(state.useCase)) { score += 12; reasons.push(`Common fit for ${labelForUseCase(state.useCase)}`); }
  if (state.useCase === 'contractor' && product.type.includes('value')) { score += 8; reasons.push('Value-line option for price-sensitive jobs'); }
  if (state.useCase === 'customer-supplied' && product.type.includes('value')) { score += 10; reasons.push('Supported alternative to random online equipment'); }

  if (state.voltage === 'any') {
    if (product.voltages.length) reasons.push(`${product.voltage} electrical requirement identified`);
  } else if (product.voltages.includes(state.voltage)) {
    score += 8;
    reasons.push(`${state.voltage} matches selected power`);
  } else {
    score -= 40;
    cautions.push(`Incompatible with selected ${state.voltage} power`);
  }

  if (product.available) { score += 7; reasons.push('In stock'); } else { score -= 18; cautions.push('Currently marked out of stock'); }

  if (state.priority === 'ship-fast') {
    score += 12;
    reasons.push(`In-stock ${product.brand || product.vendor} fast-ship brand`);
  }
  if (state.priority === 'high-efficiency') {
    const efficiencyWeight = Math.round(((product.seer2 - 13) / 17) * 20);
    score += efficiencyWeight;
    reasons.push(`${formatSeer2(product.seer2)} SEER2 verified product rating`);
  }
  if (state.priority === 'best-value' && product.price <= 1400 && product.type.includes('value')) score += 8;
  if (state.priority === 'contractor-margin' && product.type === 'value-line') { score += 14; reasons.push('Margin-friendly value-line system'); }
  if (state.priority === 'confidence') {
    score += 12;
    reasons.push('DIY-tagged option for non-expert buyers');
  }

  if (state.audience === 'homeowner') {
    if (!product.homeowner && !(state.useCase === 'large' || sqft >= 1100)) score -= 45;
    if (product.btu >= 30000 && sqft < 1000 && state.useCase !== 'large') { score -= 28; cautions.push('Usually too large for homeowner problem-room path'); }
  }
  if (state.audience === 'property') {
    if (!product.property) score -= 20;
  }
  if (state.audience === 'contractor') {
    if (product.contractor) score += 6;
    if (product.btu >= 30000) reasons.push('Available in contractor full range');
  }

  score = Math.max(0, Math.min(99, Math.round(score)));
  return { score, reasons: unique(reasons).slice(0, 4), cautions: unique(cautions).slice(0, 3), target, matchedBtu };
}

function rankedProducts() {
  return PRODUCTS.filter(product => voltageCompatibilityGate(product))
    .filter(product => priorityEligibilityGate(product))
    .map(product => ({ ...product, match: scoreProduct(product) }))
    .filter(product => audienceGate(product))
    .filter(product => filterGate(product))
    .filter(product => laneGate(product))
    .sort(sortProducts);
}

function audienceGate(product) {
  const sqft = Number(state.sqft) || 0;
  if (state.audience === 'contractor') return true;
  if (state.audience === 'property') return product.property || product.btu <= 36000;
  if (state.useCase === 'large' || sqft >= 1000) return product.homeowner || product.btu <= 36000;
  return product.homeowner && product.btu <= 24000;
}
function filterGate(product) {
  const f = state.filters;
  if (f.btu.size && !product.indoorBtus.some(capacity => f.btu.has(String(capacity)))) return false;
  if (f.brand.size && !f.brand.has(product.vendor)) return false;
  if (f.voltage.size && !product.voltages.some(voltage => f.voltage.has(voltage))) return false;
  if (f.availability.size) {
    const key = product.available ? 'In stock' : 'Out of stock';
    if (!f.availability.has(key)) return false;
  }
  if (f.efficiency.size) {
    const key = efficiencyBand(product.seer2);
    if (!f.efficiency.has(key)) return false;
  }
  if (f.type.size && !f.type.has(product.productType)) return false;
  return true;
}
function laneGate(product) {
  if (state.lane === 'top') return product.match.score >= 78;
  if (state.lane === 'value') return product.type.includes('value');
  if (state.lane === 'pro') return state.audience === 'contractor' ? product.btu >= 18000 || product.type === 'pro-range' : product.btu >= 24000;
  return true;
}
function sortProducts(a, b) {
  if (state.sort === 'price-low') return a.price - b.price;
  if (state.sort === 'price-high') return b.price - a.price;
  if (state.sort === 'btu-low') return a.btu - b.btu;
  if (state.sort === 'seer-high') return b.seer2 - a.seer2;
  return b.match.score - a.match.score || a.price - b.price;
}

function labelForUseCase(useCase) {
  if (!useCase) return 'Select a job';
  const map = { bedroom: 'bedroom or office', office: 'office', garage: 'garage or workshop', sunroom: 'sunroom', adu: 'ADU or addition', rental: 'rental or property', large: 'large space', contractor: 'price-sensitive job', 'customer-supplied': 'customer-supplied rescue', 'light-commercial': 'light commercial' };
  return map[useCase] || useCase;
}
function audienceTitle() {
  return state.audience === 'contractor' ? 'Contractor' : state.audience === 'property' ? 'Property / rental' : 'Homeowner';
}
function ctaLabel() {
  return state.audience === 'contractor' ? 'Add to quote' : 'Add to shortlist';
}

function renderAll() {
  renderUseCases();
  renderStepVisibility();
  renderJourney();
  renderRecommendations();
  renderFilters();
  renderProducts();
  renderTray();
  renderContractorCopy();
  updateModalDefaults();
}

function renderUseCases() {
  const grid = document.getElementById('useCaseGrid');
  const choices = useCaseConfig[state.audience] || useCaseConfig.homeowner;
  const ids = choices.map(choice => choice.id);
  if (state.useCase && !ids.includes(state.useCase)) state.useCase = '';
  grid.innerHTML = choices.map(choice => `
    <button class="usecase-card ${choice.id === state.useCase ? 'active' : ''}" type="button" aria-pressed="${choice.id === state.useCase ? 'true' : 'false'}" data-usecase="${escapeHTML(choice.id)}" data-sqft="${choice.sqft}" data-load="${choice.load}">
      <span class="icon" aria-hidden="true">${escapeHTML(choice.icon)}</span>
      <strong>${escapeHTML(choice.title)}</strong>
      <span>${escapeHTML(choice.text)}</span>
    </button>
  `).join('');
  document.getElementById('useCaseHeadline').textContent = state.audience === 'contractor' ? 'What job are you trying to keep moving?' : state.audience === 'property' ? 'What property comfort problem are you standardizing?' : 'What space are you trying to fix?';
  document.getElementById('useCaseSubhead').textContent = state.audience === 'contractor' ? 'Contractors can go straight to a quote-ready product package without hiding the full catalog.' : 'Choose the use case. The deck reorders around the job instead of forcing buyers to decode every SKU.';
}
function setInputValue(id, value) { const el = document.getElementById(id); if (el) el.value = value; }

function stepValid(step) {
  if (step === 1) return Boolean(state.useCase);
  if (step === 2) {
    const sqft = Number(state.sqft);
    return Number.isFinite(sqft) && sqft >= 100 && sqft <= 2500 && Boolean(state.loadProfile) && Boolean(state.voltage);
  }
  if (step === 3) return Boolean(state.priority);
  if (step === 4) return stepValid(1) && stepValid(2) && stepValid(3);
  return true;
}
function firstInvalidStep(limit = 4) {
  for (let step = 1; step <= limit; step += 1) if (!stepValid(step)) return step;
  return 0;
}
function canAccessStep(step) {
  for (let prior = 1; prior < step; prior += 1) if (!stepValid(prior)) return false;
  return true;
}
function validationMessageForStep(step) {
  if (step === 1) return 'Select one space or job card before continuing.';
  if (step === 2) return 'Enter a valid space size from 100 to 2,500 sq ft and confirm the setup fields.';
  if (step === 3) return 'Select one decision priority before viewing recommendations.';
  if (step === 4) return 'Complete the required builder selections before viewing matched products.';
  return '';
}
function clearValidation() { state.validationMessage = ''; }
function moveToStep(step) {
  const targetStep = Math.max(1, Math.min(4, Number(step) || 1));
  if (canAccessStep(targetStep)) {
    state.activeStep = targetStep;
    clearValidation();
  } else {
    const invalid = firstInvalidStep(targetStep - 1) || 1;
    state.activeStep = invalid;
    state.validationMessage = validationMessageForStep(invalid);
  }
  renderAll();
}
function validateCurrentStep() {
  if (stepValid(state.activeStep)) {
    clearValidation();
    return true;
  }
  state.validationMessage = validationMessageForStep(state.activeStep);
  renderStepVisibility();
  return false;
}
function allRequiredSelectionsComplete() {
  return stepValid(4);
}


function renderStepVisibility() {
  if (!canAccessStep(state.activeStep)) {
    state.activeStep = firstInvalidStep(state.activeStep - 1) || 1;
  }
  document.querySelectorAll('.step-tab').forEach(tab => {
    const step = Number(tab.dataset.step);
    const isActive = step === state.activeStep;
    const isAccessible = canAccessStep(step);
    tab.classList.toggle('active', isActive);
    tab.classList.toggle('is-disabled', !isAccessible);
    tab.disabled = !isAccessible;
    tab.setAttribute('aria-disabled', String(!isAccessible));
    tab.setAttribute('aria-current', isActive ? 'step' : 'false');
  });
  document.querySelectorAll('.step-panel').forEach(panel => panel.classList.toggle('active', Number(panel.dataset.stepPanel) === state.activeStep));
  document.getElementById('progressFill').style.width = `${state.activeStep * 25}%`;
  document.getElementById('progressText').textContent = `Step ${state.activeStep} of 4`;
  const prev = document.getElementById('prevStep');
  const next = document.getElementById('nextStep');
  const canContinue = stepValid(state.activeStep);
  prev.disabled = state.activeStep === 1;
  next.textContent = state.activeStep === 4 ? 'View matched products' : 'Continue';
  next.disabled = !canContinue;
  next.classList.toggle('is-disabled', !canContinue);
  next.setAttribute('aria-disabled', String(!canContinue));
  document.querySelectorAll('.contractor-only').forEach(el => el.style.display = state.audience === 'contractor' ? 'block' : 'none');
  document.querySelectorAll('.homeowner-only').forEach(el => el.style.display = state.audience === 'homeowner' ? 'block' : 'none');
  if (state.audience !== 'contractor' && state.priority === 'contractor-margin') state.priority = '';
  document.querySelectorAll('.priority-card').forEach(btn => {
    const isActive = btn.dataset.priority === state.priority;
    btn.classList.toggle('active', isActive);
    btn.setAttribute('aria-pressed', String(isActive));
    btn.type = 'button';
  });
}

function renderJourney() {
  document.getElementById('railAudienceTitle').textContent = audienceTitle();
  const target = requiredBtu();
  const summary = [
    ['Audience', audienceTitle()],
    ['Job', state.useCase ? labelForUseCase(state.useCase) : 'Choose in Step 1'],
    ['Space', stepValid(2) ? `${state.sqft} sq ft` : 'Enter in Step 2'],
    ['Starting BTU', stepValid(2) ? btu(target) : 'Pending'],
    ['Power', state.voltage === 'any' ? 'Not sure / any' : state.voltage],
    ['Priority', state.priority ? priorityLabel(state.priority) : 'Choose in Step 3']
  ];
  document.getElementById('journeySummary').innerHTML = summary.map(([label, value]) => `<div class="summary-item"><span>${escapeHTML(label)}</span><strong>${escapeHTML(value)}</strong></div>`).join('');
  const title = state.audience === 'contractor' ? 'Quote-ready job package' : state.audience === 'property' ? 'Repeatable property package' : 'Room-first recommendations';
  const text = state.audience === 'contractor'
    ? 'Ranks value-line options and builds a quote-ready tray.'
    : state.audience === 'property'
      ? 'Prioritizes repeatable, in-stock systems for similar units.'
      : 'Keeps sizing safe and explains each match plainly.';
  document.getElementById('pathOutcomeTitle').textContent = title;
  document.getElementById('pathOutcomeText').textContent = text;
  const stickyTitle = document.getElementById('stickyTitle');
  const stickySubtitle = document.getElementById('stickySubtitle');
  if (stickyTitle) stickyTitle.textContent = `${audienceTitle()} path: ${state.useCase ? labelForUseCase(state.useCase) : 'setup in progress'}`;
  if (stickySubtitle) stickySubtitle.textContent = stepValid(2) ? `${btu(target)} starting estimate - ${state.sqft} sq ft - ${state.priority ? priorityLabel(state.priority) : 'priority not selected'}` : 'Enter space size to estimate capacity';
}
function priorityLabel(priority) {
  return ({ 'best-value': 'Best overall value', 'ship-fast': 'Ships fast', 'high-efficiency': 'Highest efficiency', 'contractor-margin': 'Contractor margin', 'confidence': 'Most confident' })[priority] || 'Choose in Step 3';
}

function emptyRecommendationCopy() {
  if (state.priority === 'confidence') {
    return {
      title: 'No DIY-tagged system matches this setup.',
      text: 'Try “Not sure / any” for power, adjust the room details, or ask South Mini Splits to confirm a beginner-friendly option.'
    };
  }
  if (state.priority === 'ship-fast') {
    return {
      title: 'No in-stock fast-ship brand matches this setup.',
      text: 'This route only includes in-stock Cooper & Hunter, OLMO, and Bravo systems. Try “Not sure / any” for power or choose another priority.'
    };
  }
  if (state.priority === 'high-efficiency') {
    return {
      title: 'No product with a valid SEER2 rating matches this setup.',
      text: 'This route requires a populated 13.0–30.0 SEER2 metafield. Try “Not sure / any” for power, adjust the room details, or choose another priority.'
    };
  }
  return {
    title: 'No electrically compatible system is currently eligible.',
    text: 'Try “Not sure / any” for power or ask South Mini Splits to review the project. The builder will not substitute a different voltage.'
  };
}

function renderRecommendations() {
  const board = document.getElementById('recommendationBoard');
  if (!board) return;
  if (!allRequiredSelectionsComplete()) {
    board.innerHTML = `<div class="board-empty"><h3>Complete the builder to see matches.</h3><p>${escapeHTML(validationMessageForStep(firstInvalidStep() || state.activeStep))}</p></div>`;
    return;
  }
  const ranked = rankedProducts();
  const top = ranked[0];
  const alternates = ranked.slice(1, 4);
  if (!top) {
    const empty = emptyRecommendationCopy();
    board.innerHTML = `<div class="board-empty"><h3>${escapeHTML(empty.title)}</h3><p>${escapeHTML(empty.text)}</p></div>`;
    return;
  }
  const caution = top.match.cautions.length ? `<span class="fit-pill warning-pill">${escapeHTML(top.match.cautions[0])}</span>` : '<span class="fit-pill">Best starting point</span>';
  const liveMatch = document.getElementById('heroLiveMatch');
  if (liveMatch) {
    liveMatch.innerHTML = `
      <div class="live-product">
        <img src="${top.image}" alt="${escapeHTML(top.title)}" />
        <div class="live-score"><div class="score-ring" style="--score:${top.match.score}"><span>${top.match.score}%</span></div><div><strong>${escapeHTML(shortTitle(top))}</strong><p class="muted">${escapeHTML(capacitySummary(top))} - ${escapeHTML(top.voltage)} - ${money(top.price)}</p></div></div>
        <div class="live-reasons">${top.match.reasons.slice(0,3).map(reason => `<div><span class="check">✓</span>${escapeHTML(reason)}</div>`).join('')}</div>
        <button class="btn btn-primary full" type="button" data-product-action="quick" data-id="${top.id}">Review top match</button>
      </div>`;
  }
  board.innerHTML = `
    <div class="board-primary">
      <img src="${top.image}" alt="${escapeHTML(top.title)}" />
      <div class="board-copy">
        <div class="board-label-row"><span class="mini-label">Top match</span>${caution}</div>
        <h3>${escapeHTML(shortTitle(top))}</h3>
        <p>${escapeHTML(productExplanation(top))}</p>
        <div class="spec-chip-row"><span class="spec-chip">${escapeHTML(capacitySummary(top))}</span><span class="spec-chip">${escapeHTML(top.voltage)}</span>${top.seer2 ? `<span class="spec-chip">${formatSeer2(top.seer2)} SEER2</span>` : ''}</div>
        <div class="reason-list compact-reasons">${top.match.reasons.slice(0,2).map(reason => `<div><span class="check">✓</span> ${escapeHTML(reason)}</div>`).join('')}</div>
        <div class="board-primary-actions"><button class="btn btn-primary" type="button" data-product-action="add" data-id="${top.id}">${ctaLabel()}</button><button class="btn btn-blue" type="button" data-scroll-target="products">View matched products</button><button class="btn btn-ghost" type="button" data-product-action="quick" data-id="${top.id}">Quick view</button></div>
      </div>
    </div>
    <div class="board-side">
      <span class="mini-label">Good alternatives</span>
      ${alternates.map(product => miniProductRow(product)).join('') || '<p class="muted">No alternates match the current filters.</p>'}
    </div>`;
}
function shortTitle(product) {
  return `${product.vendor} ${product.series} ${indoorCapacityLabel(product)}`;
}
function productExplanation(product) {
  if (state.audience === 'contractor') return `${product.type.replaceAll('-', ' ')} fit with capacity, voltage, stock, and quote path visible.`;
  if (state.audience === 'property') return `Repeatable ${product.vendor} fit balancing comfort, cost control, and availability.`;
  return `Room-first fit with capacity, voltage, and install checks kept close.`;
}
function miniProductRow(product) {
  return `<div class="mini-product-row"><img src="${product.image}" alt="${escapeHTML(product.title)}" /><div><strong>${escapeHTML(shortTitle(product))}</strong><span>${product.match.score}% fit · ${money(product.price)}</span></div><button class="btn btn-soft" type="button" data-product-action="quick" data-id="${product.id}">View</button></div>`;
}

function renderFilters() {
  const facets = {
    facetBtu: unique(PRODUCTS.flatMap(p => p.indoorBtus.map(String))).sort((a,b) => Number(a)-Number(b)).map(value => ({ label: btu(value), value, set: 'btu' })),
    facetBrand: unique(PRODUCTS.map(p => p.vendor)).map(value => ({ label: value, value, set: 'brand' })),
    facetVoltage: unique(PRODUCTS.flatMap(p => p.voltages)).map(value => ({ label: value, value, set: 'voltage' })),
    facetAvailability: ['In stock','Out of stock'].map(value => ({ label: value, value, set: 'availability' })),
    facetEfficiency: ['24.0–30.0 SEER2','20.0–23.9 SEER2','16.0–19.9 SEER2','13.0–15.9 SEER2'].map(value => ({ label: value, value, set: 'efficiency' })),
    facetType: unique(PRODUCTS.map(p => p.productType)).map(value => ({ label: value, value, set: 'type' }))
  };
  Object.entries(facets).forEach(([id, options]) => {
    const element = document.getElementById(id);
    if (!element) return;
    element.innerHTML = options.map(option => {
      const checked = state.filters[option.set].has(option.value);
      const count = PRODUCTS.filter(product => facetCountGate(product, option.set, option.value)).length;
      return `<label class="facet-option"><span><input type="checkbox" data-filter-set="${option.set}" value="${escapeHTML(option.value)}" ${checked ? 'checked' : ''}> ${escapeHTML(option.label)}</span><small>${count}</small></label>`;
    }).join('');
  });
  const chips = [];
  Object.entries(state.filters).forEach(([setName, set]) => set.forEach(value => chips.push(`<button data-remove-filter="${setName}" data-value="${escapeHTML(value)}">${escapeHTML(value)} ×</button>`)));
  document.getElementById('activeFilterChips').innerHTML = chips.join('');
}
function facetCountGate(product, setName, value) {
  if (setName === 'btu') return product.indoorBtus.some(capacity => String(capacity) === value);
  if (setName === 'brand') return product.vendor === value;
  if (setName === 'voltage') return product.voltages.includes(value);
  if (setName === 'availability') return (product.available ? 'In stock' : 'Out of stock') === value;
  if (setName === 'efficiency') return efficiencyBand(product.seer2) === value;
  if (setName === 'type') return product.productType === value;
  return false;
}

function renderProducts() {
  const ranked = rankedProducts();
  document.getElementById('resultCount').textContent = ranked.length;
  const top = ranked[0];
  document.getElementById('topSystemStrip').innerHTML = top ? `
    <img src="${top.image}" alt="${escapeHTML(top.title)}" />
    <div>
      <span class="mini-label">Current best fit</span>
      <h3>${escapeHTML(shortTitle(top))}</h3>
      <p>${top.match.score}% fit score. ${escapeHTML((top.match.reasons[0] || 'Matched to your current path.'))}</p>
    </div>
    <button class="btn btn-primary" type="button" data-product-action="add" data-id="${top.id}">${ctaLabel()}</button>` : '<p>No products match the current filters.</p>';
  const deck = document.getElementById('productDeck');
  if (!ranked.length) {
    deck.innerHTML = `<div class="empty-state"><h3>No products match this exact path.</h3><p>Clear a technical filter or send the setup to South Mini Splits for a recommendation.</p><button class="btn btn-blue" type="button" id="emptyClear">Clear filters</button></div>`;
    return;
  }
  const visibleProducts = ranked.slice(0, state.visibleResults);
  const remaining = Math.max(0, ranked.length - visibleProducts.length);
  deck.innerHTML = visibleProducts.map(productCard).join('') + (remaining ? `<div class="empty-state"><h3>${remaining.toLocaleString()} more matching systems</h3><p>The complete eligible collection has been ranked. Load the next group without rendering thousands of cards at once.</p><button class="btn btn-blue" type="button" id="loadMoreProducts">Load 48 more</button></div>` : '');
}
function productCard(product) {
  const stockText = product.available ? 'In stock' : 'Out of stock';
  const badge = product.match.score >= 82 ? 'Best fit' : product.match.score >= 68 ? 'Good fit' : 'Check specs';
  const reasonHtml = product.match.reasons.slice(0, 3).map(reason => `<div><span class="check">✓</span> ${escapeHTML(reason)}</div>`).join('') + product.match.cautions.slice(0, 1).map(caution => `<div><span class="check">!</span> ${escapeHTML(caution)}</div>`).join('');
  return `
    <article class="product-card" data-id="${product.id}">
      <div class="product-media"><img src="${product.image}" alt="${escapeHTML(product.title)}" /><span class="product-badge">${escapeHTML(badge)}</span><button class="product-heart cstm_whislist_icon wishList" type="button" data-product-handle="${escapeHTML(product.handle)}" aria-label="Save ${escapeHTML(product.title)} to wishlist">♡</button></div>
      <div class="product-main">
        <span class="mini-label">${escapeHTML(product.vendor)} / ${escapeHTML(product.series)}</span>
        <h3>${escapeHTML(product.title)}</h3>
        <p>${escapeHTML(productExplanation(product))}</p>
        <div class="spec-chip-row"><span class="spec-chip">${escapeHTML(capacitySummary(product))}</span><span class="spec-chip">${product.minSqft}-${product.maxSqft} sq ft</span><span class="spec-chip">${escapeHTML(product.voltage)}</span>${product.seer2 ? `<span class="spec-chip">${formatSeer2(product.seer2)} SEER2</span>` : ''}<span class="spec-chip">${stockText}</span></div>
        <div class="reason-list">${reasonHtml}</div>
      </div>
      <div class="product-buy">
        <div class="price-block">${priceBlock(product)}</div>
        <div class="score-block"><strong>${product.match.score}%</strong><span>fit score</span></div>
        <div class="card-actions"><button class="btn btn-primary" type="button" data-product-action="add" data-id="${product.id}">${ctaLabel()}</button><button class="btn btn-ghost" type="button" data-product-action="quick" data-id="${product.id}">Quick view</button><a class="product-link" href="${product.url}">View PDP</a></div>
      </div>
    </article>`;
}

function renderTray() {
  document.getElementById('trayTitle').textContent = state.audience === 'contractor' ? 'Quote tray' : 'Shortlist';
  document.getElementById('trayCount').textContent = state.tray.length;
  document.getElementById('trayAction').textContent = state.audience === 'contractor' ? 'Send quote tray' : 'Review shortlist';
  const el = document.getElementById('trayItems');
  if (!state.tray.length) {
    el.className = 'tray-items empty';
    el.textContent = 'No products selected yet.';
    return;
  }
  el.className = 'tray-items';
  el.innerHTML = state.tray.map(id => PRODUCTS.find(p => String(p.id) === String(id))).filter(Boolean).map(product => `<div class="tray-item"><strong>${escapeHTML(shortTitle(product))}</strong><span>${btu(product.btu)} - ${money(product.price)}</span></div>`).join('');
}

function renderContractorCopy() {
  const title = document.getElementById('quotePlayTitle');
  const text = document.getElementById('quotePlayText');
  const checklist = document.getElementById('quoteChecklist');
  if (!title || !text || !checklist) return;
  const data = contractorPlayCopy(state.quotePlay);
  title.textContent = data.title;
  text.textContent = data.text;
  checklist.innerHTML = data.checklist.map(item => `<div><span class="check">✓</span>${escapeHTML(item)}</div>`).join('');
}
function contractorPlayCopy(play) {
  const map = {
    'lost-job': { title: 'Recover a premium quote that stalled on price', text: 'Use the deck to find a supported value-line alternative without attacking your premium brand.', checklist: ['Room size and application', 'Premium package or budget target', 'Preferred capacity and voltage', 'Accessories and line-set path'] },
    'customer-supplied': { title: 'Replace customer-supplied equipment risk', text: 'Build a contractor-sourced package so the installer controls equipment selection and support path.', checklist: ['Customer equipment they found online', 'Installer concerns and callback risk', 'Supported alternative system', 'Warranty and documentation path'] },
    'rental': { title: 'Standardize rental comfort packages', text: 'Rank repeatable systems for tenant comfort, turns, ADUs, and budget-controlled replacements.', checklist: ['Property type and unit size', 'Repeat order potential', 'Stock and shipping timeline', 'Accessory package and install notes'] },
    default: { title: 'Send one price-sensitive job to quote', text: 'Select a contractor play or add products from the deck. The CTA stays aligned to the ABM motion.', checklist: ['Application and square footage', 'Voltage and capacity need', 'Brand or value-line preference', 'Timeline and accessories'] }
  };
  return map[play] || map.default;
}

function quickView(product) {
  document.getElementById('quickTitle').textContent = shortTitle(product);
  document.getElementById('quickSubtitle').textContent = `${capacitySummary(product)} - ${product.voltage} - ${money(product.price)} - ${product.match.score}% fit`;
  const reasons = product.match.reasons.map(r => `<div><span class="check">✓</span> ${escapeHTML(r)}</div>`).join('');
  const cautions = product.match.cautions.map(r => `<div><span class="check">!</span> ${escapeHTML(r)}</div>`).join('');
  document.getElementById('quickViewBody').innerHTML = `
    <div class="quick-grid">
      <img src="${product.image}" alt="${escapeHTML(product.title)}" />
      <div>
        <h3>${escapeHTML(product.title)}</h3>
        <p>${escapeHTML(productExplanation(product))}</p>
        <div class="price-block">${priceBlock(product)}</div>
        <div class="quick-specs">
          <div><strong>${escapeHTML(indoorCapacityLabel(product))}</strong><span>Indoor-unit capacity</span></div>
          <div><strong>${btu(product.totalBtu)}</strong><span>Total system capacity</span></div>
          <div><strong>${product.minSqft}-${product.maxSqft}</strong><span>Sq ft guidance</span></div>
          <div><strong>${product.voltage}</strong><span>Electrical</span></div>
          <div><strong>${formatSeer2(product.seer2)}</strong><span>SEER2</span></div>
          <div><strong>${product.refrigerant}</strong><span>Refrigerant</span></div>
        </div>
        <div class="reason-list">${reasons}${cautions}</div>
        <div style="margin-top:18px;display:flex;gap:10px;flex-wrap:wrap"><button class="btn btn-primary" type="button" data-product-action="add" data-id="${product.id}">${ctaLabel()}</button><button class="btn btn-soft" type="button" data-open-modal="recommendation">Ask about this system</button></div>
      </div>
    </div>`;
  openModal('quickViewModal');
}
function persistTray() {
  try { window.localStorage.setItem('smsBuilderTray', JSON.stringify(state.tray)); } catch (error) {}
}
function addProduct(productId) {
  if (!state.tray.map(String).includes(String(productId))) state.tray.push(productId);
  persistTray();
  renderTray();
}
function openModal(id) {
  const modal = document.getElementById(id);
  if (modal) { modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); updateModalDefaults(); }
}
function closeModal(modal) { if (!modal) return; modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); }
function updateModalDefaults() {
  const selected = state.tray.map(id => PRODUCTS.find(p => String(p.id) === String(id))).filter(Boolean).map(shortTitle).join('; ');
  setInputValue('modalBuyerType', audienceTitle());
  setInputValue('modalSqft', state.sqft ? `${state.sqft} sq ft` : 'Not entered');
  setInputValue('modalJobType', labelForUseCase(state.useCase));
  setInputValue('modalQuoteProducts', selected || 'No products selected');
  setInputValue('modalRecommendProducts', selected || 'No products selected');
  const notes = document.getElementById('modalNotes');
  if (notes && !notes.dataset.touched) notes.value = `${audienceTitle()} path - ${labelForUseCase(state.useCase)} - ${state.sqft ? state.sqft + ' sq ft' : 'sq ft not entered'} - ${state.voltage === 'any' ? 'power not sure' : state.voltage} - starting estimate ${state.sqft ? btu(requiredBtu()) : 'BTU pending'}.`;
}

function scrollToSection(id) {
  const target = document.getElementById(id);
  if (!target) return;
  const header = document.querySelector('.topbar');
  const offset = (header ? header.offsetHeight : 0) + 14;
  const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function revealProductsAndScroll() {
  if (!allRequiredSelectionsComplete()) {
    const invalid = firstInvalidStep() || state.activeStep;
    state.activeStep = invalid;
    state.validationMessage = validationMessageForStep(invalid);
    renderAll();
    scrollToSection('builder');
    return;
  }
  const products = document.getElementById('products');
  if (!products) return;
  products.classList.remove('is-hidden');
  products.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(() => scrollToSection('products'));
}

function bindEvents() {
  document.addEventListener('click', async event => {
    const audienceBtn = event.target.closest('[data-audience]');
    if (audienceBtn) {
      state.audience = audienceBtn.dataset.audience;
      document.querySelectorAll('[data-audience]').forEach(btn => btn.classList.toggle('active', btn.dataset.audience === state.audience));
      state.useCase = '';
      state.priority = '';
      state.visibleResults = 48;
      state.activeStep = 1;
      state.sqft = '';
      state.loadProfile = 'normal';
      clearValidation();
      setInputValue('sqftInput', state.sqft); setInputValue('loadProfile', state.loadProfile);
      const products = document.getElementById('products');
      if (products) { products.classList.add('is-hidden'); products.setAttribute('aria-hidden', 'true'); }
      renderAll();
    }
    const useCaseBtn = event.target.closest('[data-usecase]');
    if (useCaseBtn) {
      state.useCase = useCaseBtn.dataset.usecase;
      state.sqft = Number(useCaseBtn.dataset.sqft) || state.sqft;
      state.loadProfile = useCaseBtn.dataset.load || state.loadProfile;
      state.visibleResults = 48;
      setInputValue('sqftInput', state.sqft); setInputValue('loadProfile', state.loadProfile);
      clearValidation();
      renderAll();
    }
    const stepBtn = event.target.closest('[data-step]');
    if (stepBtn) {
      const requestedStep = Number(stepBtn.dataset.step);
      if (requestedStep === 4 && canAccessStep(4)) await ensureCompleteCatalog();
      moveToStep(requestedStep);
    }
    const priorityBtn = event.target.closest('[data-priority]');
    if (priorityBtn) { state.priority = priorityBtn.dataset.priority; state.visibleResults = 48; clearValidation(); renderAll(); }
    const laneBtn = event.target.closest('[data-lane]');
    if (laneBtn) { state.lane = laneBtn.dataset.lane; state.visibleResults = 48; document.querySelectorAll('[data-lane]').forEach(btn => btn.classList.toggle('active', btn.dataset.lane === state.lane)); renderProducts(); }
    const actionBtn = event.target.closest('[data-product-action]');
    if (actionBtn) {
      const product = PRODUCTS.find(p => String(p.id) === String(actionBtn.dataset.id));
      if (!product) return;
      const ranked = { ...product, match: scoreProduct(product) };
      if (actionBtn.dataset.productAction === 'quick') quickView(ranked);
      if (actionBtn.dataset.productAction === 'add') addProduct(product.id);
    }
    const emptyClear = event.target.closest('#emptyClear');
    if (emptyClear) { Object.values(state.filters).forEach(set => set.clear()); state.visibleResults = 48; renderAll(); }
    const loadMoreProducts = event.target.closest('#loadMoreProducts');
    if (loadMoreProducts) { state.visibleResults += 48; renderProducts(); }
    const scrollBtn = event.target.closest('[data-scroll-target]');
    if (scrollBtn) {
      event.preventDefault();
      if (scrollBtn.dataset.scrollTarget === 'products') revealProductsAndScroll();
      else scrollToSection(scrollBtn.dataset.scrollTarget);
    }
    const modalBtn = event.target.closest('[data-open-modal]');
    if (modalBtn) openModal(modalBtn.dataset.openModal === 'quote' ? 'quoteModal' : 'recommendationModal');
    const closeBtn = event.target.closest('[data-close-modal]');
    if (closeBtn) closeModal(closeBtn.closest('.modal'));
    const removeFilter = event.target.closest('[data-remove-filter]');
    if (removeFilter) { state.filters[removeFilter.dataset.removeFilter].delete(removeFilter.dataset.value); renderAll(); }
    const playBtn = event.target.closest('[data-play]');
    if (playBtn) { state.quotePlay = playBtn.dataset.play; state.audience = 'contractor'; document.querySelectorAll('[data-audience]').forEach(btn => btn.classList.toggle('active', btn.dataset.audience === state.audience)); document.querySelectorAll('[data-play]').forEach(btn => btn.classList.toggle('active', btn.dataset.play === state.quotePlay)); if (state.quotePlay === 'rental') state.useCase = 'rental'; if (state.quotePlay === 'customer-supplied') state.useCase = 'customer-supplied'; if (state.quotePlay === 'lost-job') state.useCase = 'contractor'; state.priority = 'contractor-margin'; renderAll(); scrollToSection('builder'); }
  });

  document.querySelectorAll('[data-sms-builder-source] .modal').forEach(modal => modal.addEventListener('click', event => { if (event.target === modal) closeModal(modal); }));
  document.getElementById('prevStep').addEventListener('click', () => { state.activeStep = Math.max(1, state.activeStep - 1); clearValidation(); renderAll(); });
  document.getElementById('nextStep').addEventListener('click', async () => {
    if (!validateCurrentStep()) return;
    if (state.activeStep === 3) await ensureCompleteCatalog();
    if (state.activeStep === 4) {
      renderAll();
      revealProductsAndScroll();
    } else {
      state.activeStep += 1;
      clearValidation();
      renderAll();
    }
  });
  document.getElementById('sqftInput').addEventListener('input', event => { state.sqft = Number(event.target.value) || ''; clearValidation(); renderAll(); });
  document.getElementById('loadProfile').addEventListener('change', event => { state.loadProfile = event.target.value; clearValidation(); renderAll(); });
  document.getElementById('voltageSelect').addEventListener('change', event => { state.voltage = event.target.value; state.visibleResults = 48; clearValidation(); renderAll(); });
  document.getElementById('sortSelect').addEventListener('change', event => { state.sort = event.target.value; state.visibleResults = 48; renderProducts(); });
  document.getElementById('filterPanel').addEventListener('change', event => {
    const input = event.target.closest('[data-filter-set]');
    if (!input) return;
    const set = state.filters[input.dataset.filterSet];
    if (input.checked) set.add(input.value); else set.delete(input.value);
    state.visibleResults = 48;
    renderAll();
  });
  document.querySelectorAll('.facet-head').forEach(btn => btn.addEventListener('click', () => { const facet = btn.closest('.facet'); facet.classList.toggle('open'); btn.querySelector('span').textContent = facet.classList.contains('open') ? '-' : '+'; }));
  document.getElementById('clearFilters').addEventListener('click', () => { Object.values(state.filters).forEach(set => set.clear()); state.visibleResults = 48; renderAll(); });
  document.getElementById('resetExperience').addEventListener('click', () => { state.audience = 'homeowner'; state.useCase = ''; state.sqft = ''; state.loadProfile = 'normal'; state.voltage = 'any'; state.priority = ''; state.activeStep = 1; state.validationMessage = ''; state.lane = 'all'; state.sort = 'match'; state.visibleResults = 48; Object.values(state.filters).forEach(set => set.clear()); state.tray = []; persistTray(); const products = document.getElementById('products'); if (products) { products.classList.add('is-hidden'); products.setAttribute('aria-hidden', 'true'); } document.querySelectorAll('[data-audience]').forEach(btn => btn.classList.toggle('active', btn.dataset.audience === state.audience)); setInputValue('sqftInput', state.sqft); setInputValue('loadProfile', state.loadProfile); setInputValue('voltageSelect', state.voltage); clearValidation(); renderAll(); });
  document.getElementById('toggleFilters').addEventListener('click', () => document.getElementById('filterPanel').classList.toggle('mobile-open'));
  document.getElementById('trayAction').addEventListener('click', () => openModal(state.audience === 'contractor' ? 'quoteModal' : 'recommendationModal'));
  document.getElementById('modalNotes')?.addEventListener('input', event => { event.target.dataset.touched = 'true'; });
  const stickyDecision = document.getElementById('stickyDecision');
  if (stickyDecision) window.addEventListener('scroll', () => stickyDecision.classList.toggle('show', window.scrollY > 900));
}

bindEvents();
renderAll();
const successfulBuilderForm = document.querySelector('[data-sms-builder-success]');
if (successfulBuilderForm) openModal(successfulBuilderForm.dataset.smsBuilderSuccess);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sms-home-trusted-brands"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.brandCarouselReady === 'true') return;

      const track = root.querySelector('[data-brand-track]');
      const previous = root.querySelector('[data-brand-previous]');
      const next = root.querySelector('[data-brand-next]');

      if (!track || !previous || !next) return;

      root.dataset.brandCarouselReady = 'true';

      const scrollAmount = () => {
        const firstCard = track.querySelector('.brand-card');
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 180;
        return Math.max(cardWidth * 3, track.clientWidth * 0.7);
      };

      const updateControls = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maximum - 4;
        root.classList.toggle('brand-carousel-static', maximum <= 4);
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateControls();
          ticking = false;
        });
      });

      window.addEventListener('resize', updateControls);
      updateControls();
    };

    const initializeAll = (scope = document) => {
      if (scope.matches && scope.matches('[data-sms-brand-carousel]')) initialize(scope);
      scope.querySelectorAll('[data-sms-brand-carousel]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
